/**
 * @flow
 * @format
 */

import _Circle from './Circle';

export default _Circle;



// WEBPACK FOOTER //
// ./src/components/Circle/index.js